var $ = require('jquery');

$(function () {
    $('.edituser-form__body__submit').on('click', function (e) {
        e.preventDefault();
        var formNode = $(this).closest("form");
        var formId = formNode.attr("formid");

        if ($('.g-recaptcha[data-formid="' + formId + '"]').length) {
            let checkRecaptcha = new Promise((resolve, reject) => {
                var googleResponse = grecaptcha.getResponse();
                if (googleResponse.length === 0) {
                    reject(false);
                } else {
                    $.ajax(
                    {
                        url: "/api/Sitecore/Form/RecaptchaResponse",
                        type: "POST",
                        context: this,
                        data: { response: googleResponse },
                        success: function (data) {
                            resolve(data);
                        },
                        error: function (data) {
                            reject(false);
                        }
                    });
                }
            });
            //first check recaptcha, then check the rest
            checkRecaptcha.then(function () {
                formNode.submit();
            }).catch((rejection) => {
                formNode.find('.form__field--error').show().parent().addClass('form__field--has-error');                
            });
        } else {
            formNode.submit();
        }
    });

    $('form').keyup(function (event) {
        if (event.keyCode == 13) {
            event.preventDefault();
            $(this).find(".edituser-form__body__submit").click();
        }
    });
});